import { createSlice } from '@reduxjs/toolkit'

import { initialState } from './constants'
import { getCountriesThunk } from './thunks'

const countriesSlice = createSlice({
  name: 'countries',
  initialState,
  reducers: {
    setCountriesReady: (state) => {
      state.ready = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCountriesThunk.fulfilled, (state, action) => {
      state.countries = action.payload
      state.ready = true
    })
  },
})

export const { setCountriesReady } = countriesSlice.actions
export default countriesSlice.reducer
